import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/v1/parts'

const partsOptions = async (result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/parts-options',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const setParts = async (form, result) => {
  const options = {
    method: 'POST',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: {
      cseq: form.carSeq,
      pseq: form.partsSeq,
      date: form.selectDay,
      km: form.totalKm,
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 200) {
        result(response.data.message)
      } else {
        result(null)
      }
    })

}

const expendParts = async (cseq, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/expend',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })

}

const partsForCar = async (cseq, sdate, edate, page, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }

  const options = {
    method: 'GET',
    url: apiUrlEx + '/parts-for-car',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq,
      sdate: sdate,
      edate: edate,
      page: page || 1
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

export default {
  expendParts,
  partsForCar
}

export {
  partsOptions,
  setParts
}
